import Properties from "./Properties";
import Metadata from "./Metadata";
import Wrapper from "./Wrapper";
import Collaborators from "./collaborators";
import Ingestion from "./ingestion";
import Styles from "./Stylesheets";
import Analytics from "./Analytics";
import Sections from "./Sections";
import Section from "./section";
import TableOfContents from "./TableOfContents";
import TOCEntry from "./toc-entry";
import Assets from "./assets";

export default {
  Properties,
  Metadata,
  Wrapper,
  Collaborators,
  Ingestion,
  Styles,
  Analytics,
  Sections,
  Section,
  TableOfContents,
  TOCEntry,
  Assets
};
